export default Object.freeze({
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
})
